import styled from 'styled-components';
import { layout } from 'src/components/base';
import { CaptionText } from '@prisjakt/ui/text/variants';

export const PaymentProviders = styled.div`
  display: flex;
  gap: ${layout.measurements.spacing050};
  align-items: center;
`;

export const PaymentProviderLogotype = styled.img`
  height: ${layout.measurements.spacing100};
`;

export const PaymentProviderMoreLabel = styled(CaptionText)``;
